export default "__VITE_ASSET__DNlk986e__"